import { useContext } from "react";
import { AdminThemeContext } from "../context/AdminThemeContext";

export default function AdminSettings() {
  const { theme, setTheme } = useContext(AdminThemeContext);

  const update = (key, value) => {
    setTheme((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="card p-4">
      <h4 className="mb-4">Admin Theme Settings</h4>

      {/* <div className="mb-3">
        <label>Header Color</label>
        <input
          type="color"
          value={theme.header}
          onChange={(e) => update("header", e.target.value)}
          className="form-control form-control-color"
        />
      </div> */}

      <div className="mb-3">
        <label>Sidebar Color</label>
        <input
          type="color"
          value={theme.sidebar}
          onChange={(e) => update("sidebar", e.target.value)}
          className="form-control form-control-color"
        />
      </div>

      <div className="mb-3">
        <label>Background Color</label>
        <input
          type="color"
          value={theme.background}
          onChange={(e) => update("background", e.target.value)}
          className="form-control form-control-color"
        />
      </div>

    </div>
  );
}
